export namespace VersionActions {
    export class GetVersionData {
        public static readonly type = "[Version] Get version data";
    }
}
